import { Injectable } from '@angular/core';
import { Location } from "@angular/common";
@Injectable()
export class ToggleService {

	constructor(public location: Location) { }

	hidelogo = true;
	menutoggle() {
		this.hidelogo = !this.hidelogo;
	}

	dropdownopt = true;
	droptoggle() {
		this.dropdownopt = !this.dropdownopt;
	}

	topmenutoggle = true;
	topRtMenuToggle() {
		this.topmenutoggle = !this.topmenutoggle;
	}

	/******************/
	goBack() {
		this.location.back();
	}

}



// WEBPACK FOOTER //
// ./src/app/services/toggle/toggle.service.ts